(function () {
  if (window.GiftWithPurchase) return;

  var config = window.giftWithPurchaseConfig || null;
  var popup = null;

  function getCart() {
    return fetch('/cart.js').then(function (r) {
      return r.json();
    });
  }

  function cartHasProduct(cart, productId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return item.product_id === productId;
    });
  }

  function cartHasAnyGift(cart) {
    if (!config) return false;
    return config.gifts.some(function (gift) {
      return cartHasProduct(cart, gift.productId);
    });
  }

  // A gift-eligible product bought normally from its own product page (no
  // "_gwp" line item property) must behave like any other product - full
  // price, no free-gift styling, never auto-removed. Only a line actually
  // added through addGift() below (popup or drawer widget) carries "_gwp",
  // which is also the exact same marker the gwp-price Cart Transform
  // Function checks server-side before zeroing a line's price - so this
  // check mirrors the one source of truth for "is this a claimed gift".
  function itemIsClaimedGift(item) {
    if (!config || !item.properties || item.properties._gwp !== '1') return false;
    return config.gifts.some(function (gift) {
      return gift.productId === item.product_id;
    });
  }

  function cartHasClaimedGift(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(itemIsClaimedGift);
  }

  function resetGiftButtons(container) {
    container.querySelectorAll('[data-gift-add]').forEach(function (b) {
      var index = parseInt(b.getAttribute('data-gift-index'), 10);
      var gift = config && config.gifts[index];
      if (gift && gift.available === false) {
        b.setAttribute('disabled', 'disabled');
      } else {
        b.removeAttribute('disabled');
      }
    });
  }

  function openPopup() {
    if (!popup) return;
    resetGiftButtons(popup);
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function addGift(variantId) {
    if (!config) return Promise.reject(new Error('Missing gift with purchase config'));

    // A one-time-purchase product with subscription selling plans makes ReCharge
    // show its own "subscribe & save" dialog before the real drawer. Flag this
    // add as automatic so assets/gift-with-purchase-drawer.js auto-dismisses it
    // (clicks the "buy once" option) instead of leaving it up to the customer.
    window.__gwpSuppressUpsell = true;
    setTimeout(function () {
      window.__gwpSuppressUpsell = false;
    }, 5000);

    // The "_gwp" line item property marks this line for the gwp-price Cart
    // Transform Function, which zeroes its price server-side (only while the
    // trigger product is also in the cart) - no discount code involved, so it
    // never competes with whatever discount code the customer enters at checkout.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gwp: '1' } }] })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.message || 'Nie udało się dodać gratisu do koszyka');
        }
        return response;
      });
  }

  var reconcileInFlight = false;

  function reconcileCart() {
    if (!config || !config.enabled || !config.triggerProductId) return;
    if (reconcileInFlight) return;

    getCart().then(function (cart) {
      if (cartHasProduct(cart, config.triggerProductId)) return;

      var orphanedGifts = cart.items.filter(itemIsClaimedGift);
      if (!orphanedGifts.length) return;

      reconcileInFlight = true;

      // Keyed by line item key, not variant_id: Shopify's own docs warn that
      // when a variant_id key matches multiple lines (exactly our case - a
      // claimed gift line and a normally-bought line of the same product
      // legitimately coexist, differing only in the "_gwp" property), only
      // the FIRST matching line gets updated. Keying by variant_id here could
      // silently zero the customer's normal purchase instead of the gift.
      var updates = {};
      orphanedGifts.forEach(function (item) {
        updates[item.key] = 0;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (updatedCart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: updatedCart }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (e) {
          console.error(e);
        })
        .finally(function () {
          reconcileInFlight = false;
        });
    });
  }

  function maybeShowPopup(addedResponse) {
    if (!config || !config.enabled || !config.triggerProductId) return;
    if (!addedResponse || addedResponse.product_id !== config.triggerProductId) return;
    if (sessionStorage.getItem('gwp_popup_seen') === '1') return;

    getCart().then(function (cart) {
      if (cartHasClaimedGift(cart)) return;
      sessionStorage.setItem('gwp_popup_seen', '1');
      openPopup();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    popup = document.getElementById('gift-popup');
    if (!popup) return;

    popup.querySelectorAll('[data-gift-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    popup.querySelectorAll('[data-gift-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-gift-index'), 10);
        var gift = config.gifts[index];
        if (!gift || gift.available === false) return;

        popup.querySelectorAll('[data-gift-add]').forEach(function (b) {
          b.setAttribute('disabled', 'disabled');
        });

        addGift(gift.variantId)
          .then(function () {
            closePopup();
          })
          .catch(function (e) {
            console.error(e);
            resetGiftButtons(popup);
          });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // Backstop: the trigger product can be removed from anywhere (the standalone
    // /cart page uses its own AJAX flow that never touches the ReCharge drawer's
    // shadow DOM), so don't rely solely on assets/gift-with-purchase-drawer.js's
    // shadow-root observer to catch an orphaned free gift.
    reconcileCart();
    setInterval(reconcileCart, 5000);
  });

  window.GiftWithPurchase = {
    config: config,
    getCart: getCart,
    cartHasProduct: cartHasProduct,
    cartHasAnyGift: cartHasAnyGift,
    itemIsClaimedGift: itemIsClaimedGift,
    cartHasClaimedGift: cartHasClaimedGift,
    addGift: addGift,
    maybeShowPopup: maybeShowPopup,
    reconcileCart: reconcileCart
  };
})();
